const { OWLS_FIVERR_CHOICE_EXPANSION } = require('../experimentsEnum');
const { inAbTest } = require('..');
const { CHOICE_ALGO_A, CHOICE_ALGO_B } = require('./constants');

const isInChoiceExpansionExp = (abTests) => inAbTest(abTests, OWLS_FIVERR_CHOICE_EXPANSION);

const isChoiceEligible = (abTests, choiceEligibilities) => {
    if (!choiceEligibilities) {
        return false;
    }
    const formattedChoiceEligibilities = choiceEligibilities.map((choice) => choice.type);

    if (isInChoiceExpansionExp(abTests)) {
        return formattedChoiceEligibilities.includes(CHOICE_ALGO_B);
    }

    return formattedChoiceEligibilities.includes(CHOICE_ALGO_A);
};

module.exports = {
    isInChoiceExpansionExp,
    isChoiceEligible
};
